import React from 'react'

import { Alert, AlertTitle } from '@mui/material';
import Grid2 from "@mui/material/Grid2";
import {useSxStyles as sx} from "../styles/sxStyles";



function AlertMessage( { title, severity, msg }) {
    return (
        (<Grid2 container sx={sx.alertContainer}>
            <Grid2 size={12}>
                <Alert severity={severity}>
                    <AlertTitle>{title}</AlertTitle>
                    {msg}
                </Alert>
            </Grid2>
        </Grid2>)
    );
}

export default AlertMessage;

